import { z } from 'zod';
export const money = z.coerce.number();
export const qty = z.coerce.number();
export const isoDateTime = z.string();
/** Shared action kinds — Verisk `-`/`+`/`&`; Symbility ActionName/ActionCode. */
export const ItemActionSchema = z.enum(['remove', 'replace', 'removeAndReplace']);
/**
 * Line kind — intersection of Verisk ITEM@type (I/N) and Symbility LineType flags.
 * `title` / `minimumCharge` are Symbility-leaning but harmless for Verisk adapters to omit.
 */
export const LineKindSchema = z.enum(['lineItem', 'note', 'title', 'minimumCharge']);
export const EstimateClassSchema = z.enum(['structure', 'contents']);
